import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "Lager_2",
  "data-name": "Lager 2",
  viewBox: "0 0 120.67 120.67"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".cls-2{fill:#4c4c4f}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("g", {
      id: "Lager_1-2",
      "data-name": "Lager 1"
    }, [
      _createElementVNode("path", {
        d: "M0 0h120.67v120.67H0z",
        style: {"fill":"#fff"}
      }),
      _createElementVNode("path", {
        d: "M46.43 46.79V17.96h28.01v56.71H18.43V46.79zM74.44 74.67h28v27.89h-28z",
        class: "cls-2"
      })
    ], -1))
  ]))
}
export default { render: render }